// import { getParentDetails, getProfileDetails, } from "@parent-app/services";
// import { ChildrenStoreData, RootState } from "@parent-app/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileAction } from "./ProfileSlice";
import { ChildrenStoreData } from "src/shared/types/src";
import { getParentDetails, getProfileDetails } from "src/shared/services/src";


export const getBasicDetailsData = createAsyncThunk(
    "getBasicDetailsData", async ({ reduxStore, child }: { reduxStore: any, child: ChildrenStoreData }, { dispatch }) => {
        try {
            dispatch(profileAction.setBasicDetailsLoading(true));
            const response = await getProfileDetails({ child });

            if (response) {
                dispatch(profileAction.setBasicDetailsData(response))
            }
        } catch (error) {
            console.log("Error fetching basic details: ", error);
        } finally {
            dispatch(profileAction.setBasicDetailsLoading(false));
        }
    }
)

export const getParentDetailsData = createAsyncThunk(
    "getParentDetailsData", async ({ reduxStore, child }: { reduxStore: any, child: ChildrenStoreData }, { dispatch }) => {
        try {
            dispatch(profileAction.setParentDetailsLoading(true));
            const response = await getParentDetails({ child });

            if (response) {
                dispatch(profileAction.setParentData(response?.parents))
            }
        } catch (error) {
            console.log("Error fetching Parents details: ", error);
        } finally {
            dispatch(profileAction.setParentDetailsLoading(false));
        }
    }
)